import { z } from "zod";

export const PasswordRequirementsSchema = z.object({
  minLength: z.number(),
  maxLength: z.number(),
  maxRepeats: z.number(),
  requireLower: z.boolean(),
  requireUpper: z.boolean(),
  requireNumber: z.boolean(),
  requireSpecial: z.boolean(),
});

export type PasswordRequirements = z.infer<typeof PasswordRequirementsSchema>;
